import type { VerificationLevel, ClaimStatus } from "../../shared/api";

const Check = () => (
  <svg viewBox="0 0 16 16" fill="none" aria-hidden>
    <path d="M13.5 4.5 6.5 11.5 3 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

/** Trust badge for a review's verification level (SPEC §2.1). */
export function VerificationBadge({ level }: { level: VerificationLevel }) {
  if (level === "none") return <span className="badge badge-neutral">Unverified</span>;
  const label =
    level === "wallet" ? "Verified Holder" : level === "exchange" ? "Verified User" : "Verified On-chain";
  return (
    <span className="badge badge-verified" title="Reviewer proved usage cryptographically">
      <Check /> {label}
    </span>
  );
}

export function ClaimBadge({ status }: { status: ClaimStatus }) {
  if (status === "claimed") return <span className="badge badge-claimed"><Check /> Claimed</span>;
  if (status === "pending") return <span className="badge badge-neutral">Claim pending</span>;
  return <span className="badge badge-neutral">Unclaimed</span>;
}

export function AuditBadge({ status }: { status: string | null | undefined }) {
  if (status === "audited") return <span className="badge badge-audited"><Check /> Audited</span>;
  if (status === "none") return <span className="badge badge-warn">No audit</span>;
  return null;
}
